exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".spaceselect{height:100%;width:200px;background:hsla(0,0%,100%,.25);padding:0 20px;text-transform:uppercase}.spaceselect .ui-select{margin:0;height:100%;align-items:center;width:200px}.spaceselect .ui-select__display{color:#fff;border:none}.spaceselect .ui-select__display-value{text-transform:uppercase;font-size:.875rem;font-weight:600}.spaceselect .ui-select__display-value.is-placeholder,.spaceselect .ui-select__dropdown-button{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-3a17f786!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/spaces/Spaceselect.vue
// module id = 471
// module chunks = 22